import { render, staticRenderFns } from "./Sponsors1.vue?vue&type=template&id=e96ab87a&scoped=true&"
import script from "./Sponsors1.vue?vue&type=script&lang=js&"
export * from "./Sponsors1.vue?vue&type=script&lang=js&"
import style0 from "./Sponsors1.vue?vue&type=style&index=0&id=e96ab87a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96ab87a",
  null
  
)

export default component.exports